export const WALLET_LIST_FETCHING = 'WALLET_LIST_FETCHING'
export const WALLET_LIST_FAILURE = 'WALLET_LIST_FAILURE'
export const WALLET_LIST_SUCCESS = 'WALLET_LIST_SUCCESS'

// filters

export const WALLET_RECEIVE_FILTERS = 'WALLET_RECEIVE_FILTERS'
export const WALLET_CLEAR_FILTERS = 'WALLET_CLEAR_FILTERS'
